var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('el-image',{staticStyle:{"height":"40px"},attrs:{"src":_vm.urLogo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }